var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#2583FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.094 38.7467C20.8738 42.0914 20.1068 44.4406 19.7932 45.7944C18.8092 50.0472 18.094 51.0045 21.7612 48.9836C25.4253 46.9627 43.1758 36.9533 47.1374 34.7295C52.299 31.8299 52.3678 32.0557 46.859 28.9761C42.6638 26.6313 25.1229 16.8836 21.7596 14.9691C18.3964 13.0546 18.8092 13.9055 19.7916 18.1583C20.1116 19.5296 20.8903 21.9001 22.1276 25.2699C22.552 26.4235 23.2589 27.4464 24.1806 28.2406C25.1023 29.0348 26.208 29.5738 27.3917 29.8058L37.6829 31.8234C37.7231 31.8313 37.7593 31.8533 37.7853 31.8855C37.8113 31.9178 37.8255 31.9583 37.8255 32.0001C37.8255 32.0419 37.8113 32.0824 37.7853 32.1147C37.7593 32.1469 37.7231 32.1689 37.6829 32.1768L27.3677 34.1928C26.1803 34.4249 25.0714 34.9658 24.1477 35.7634C23.2241 36.561 22.5168 37.5884 22.094 38.7467Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMode);
export default __webpack_public_path__ + "static/media/mode.57afc490990b3678f362069d8dbdbcd4.svg";
export { ForwardRef as ReactComponent };